import { Pipe, PipeTransform } from '@angular/core';
import { TitleCasePipe } from '@angular/common';

/*
sentenceCase pipe will put all words in lowercase except the first word and any exceptions provided
Only use when the i18n translations (en_devel) file, or the source of the strings cannot be directly edited.
Example usage: if display names are fetched from vstore.
 */
@Pipe({
  name: 'sentenceCase',
  standalone: true,
})
export class SentenceCasePipe implements PipeTransform {
  constructor(private readonly titleCase: TitleCasePipe) {}
  transform(sentence: string, ignoredWords?: string[]): string {
    if (!sentence) return sentence;
    let words = sentence.split(' ');
    words = words.map((word, index) => {
      if (ignoredWords?.includes(word.replace(/[^\w]/g, ''))) {
        return word;
      }
      if (index === 0) {
        return this.titleCase.transform(word);
      }
      return word.toLocaleLowerCase();
    });
    return words.join(' ');
  }
}
